export default __webpack_public_path__ + "static/media/regulatory--no-stopping--g3.60647b5f.png";